import { useRef, useCallback, useEffect } from "react";

function useTimeout(callback, delay) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    autoInvoke: false
  };
  const timeoutRef = useRef(null);
  const start = useCallback(function () {
    for (var _len = arguments.length, callbackParams = new Array(_len), _key = 0; _key < _len; _key++) {
      callbackParams[_key] = arguments[_key];
    }

    if (!timeoutRef.current) {
      timeoutRef.current = window.setTimeout(() => {
        callback(callbackParams);
        timeoutRef.current = null;
      }, delay);
    }
  }, [delay]);
  const clear = useCallback(() => {
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);
  useEffect(() => {
    if (options.autoInvoke) {
      start();
    }

    return clear;
  }, [clear, start]);
  return {
    start,
    clear
  };
}

export { useTimeout };